import { CheckboxMarkedCircleMinusOutlineIcon } from './CheckboxMarkedCircleMinusOutlineIcon';

/**
 * author: Jeff Anders
 * id 53428253-C1B2-47CD-BBC8-7069E7697FEF
 * name checkbox-marked-circle-minus-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-marked-circle-minus-outline.svg
 * tags
 * - Form 
 */
export const TaskMinusIcon = CheckboxMarkedCircleMinusOutlineIcon;
export default TaskMinusIcon